import React, { useState, useEffect } from "react";
import pioneerlogo from "../images/pioneerlogowhite.png";
import "./privacy_policy.css";

const Termsofuse = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className="privacy-wrapper">
            <div className="privacy-main">
                {/* Header */}
                <nav className="privacy-navbar">
                    <div className="privacy-navbar-container">
                        <a className="privacy-navbar-brand" href="/Termsofuse">
                            <img
                                src={pioneerlogo}
                                className="privacy-logo"
                                alt="Pioneer"
                            />
                        </a>
                    </div>
                </nav>
                {/* Privacy Policy Content */}
                <div className="privacy-contentmain">
                    <div className="privacy-content">
                        <h1>TERMS OF USE</h1>
                        <p className="privacy-edition">
                            Edition dated <strong>2 October 2026</strong>
                        </p>
                        <p>
                            Welcome to Vylor. These Terms of Use (“Terms”) govern your access to and use of
                            the Vylor website, online applications, digital services, content, features,
                            and resources made available through our websites and related platforms
                            (collectively, the “Services”).In these Terms, “Vylor,” “We,” “Us,” and “Our” refer to Vylor and, where
                            applicable, its affiliated entities or service providers responsible for
                            providing the Services. “You” and “Your” refer to any individual or entity
                            accessing or using the Services. <b>By accessing or using the Services, you acknowledge that you have read,
                                understood, and agree to be bound by these Terms and any additional terms or
                                policies that apply to particular Services. If you do not agree with these Terms, please do not access or use the Services.</b>
                        </p>
                        <h2>Changes to These Terms</h2>
                        <p>
                            Vylor may update or modify these Terms from time to time to reflect changes to
                            our Services, business practices, legal requirements, or other operational
                            needs. When we make changes, we may update the edition date displayed at the beginning
                            of these Terms. Updated Terms will become effective when they are posted on the
                            Services, unless otherwise stated.Your continued use of the Services after revised Terms are posted constitutes
                            your acceptance of the updated Terms.
                        </p>
                        <h2>Privacy</h2>
                        <p>
                            Your privacy is important to Us.
                        </p>
                        <p>
                            Our collection, use, storage, and disclosure of Personal Information are
                            described in the{" "}
                            <a href="/PrivacyPolicy">Vylor Privacy Notice</a>,
                            {" "}which forms an important part of your relationship with Us. Please review our Privacy Notice to understand how we process Personal
                            Information when you use our Services. Your use of the Services constitutes your acknowledgment of the practices
                            described in the applicable Privacy Notice, subject to your rights under
                            applicable law.
                        </p>
                        <h2>Additional and Third-Party Terms</h2>
                        <p>
                            Certain Services, features, applications, promotions, or functionality may be
                            subject to additional terms, conditions, rules, or policies (“Additional
                            Terms”). Where Additional Terms apply, they will be made available to you in connection
                            with the relevant Service and will form part of these Terms. The Services may also contain or provide access to products, applications,
                            websites, payment services, analytics services, social media services, or other
                            functionality operated by third parties (“Third-Party Services”). Your use of Third-Party Services may be subject to the terms and privacy
                            policies of those third parties. Vylor does not control those third parties
                            and is not responsible for their terms, policies, content, or practices.
                        </p>
                        <h2>Use of the Services</h2>
                        <p>
                            You may use the Services only for lawful purposes and in accordance with these
                            Terms.
                        </p>
                        <p>You agree that you will:</p>
                        <ul>
                            <li>provide accurate information when information is requested from you;</li>
                            <li>use the Services only for their intended purposes;</li>
                            <li>comply with all applicable laws and regulations;</li>
                            <li>respect the rights of Vylor and third parties; and</li>
                            <li>maintain the security of any account credentials associated with your use of the Services.</li>
                        </ul>
                        <p>
                            You are responsible for your activities while using the Services and for
                            ensuring that your use of the Services does not violate these Terms or
                            applicable law.
                        </p>
                        <h2>Accounts, Usernames and Passwords</h2>
                        <p>
                            Certain Vylor Services may require you to create an account. When creating an account, you agree to provide information that is accurate,
                            current, complete, and not misleading. You should update your information when
                            necessary to ensure that it remains accurate. You are responsible for maintaining the confidentiality of your username,
                            password, authentication information, and other account credentials. You must notify Vylor promptly if you believe that your account has been
                            accessed without authorization or that your account credentials have been
                            compromised.
                        </p>
                        <p>You must not:</p>
                        <ul>
                            <li>create an account using a false identity;</li>
                            <li>impersonate another person or organization;</li>
                            <li>create an account for someone else without authorization;</li>
                            <li>share your account credentials with unauthorized persons;</li>
                            <li>use an account after Vylor has suspended or terminated your access;</li>
                            <li>create multiple accounts where doing so is prohibited by the applicable Service.</li>
                        </ul>
                        <p>
                            Vylor may suspend, restrict, or terminate an account where we reasonably believe
                            that the account has been used in violation of these Terms, applicable law, or
                            the security or integrity of the Services.
                        </p>
                        <h2>Ownership and Intellectual Property</h2>
                        <p>
                            The Services and their contents, including without limitation text, graphics,
                            photographs, logos, icons, designs, layouts, software, code, videos, audio,
                            documentation, databases, trademarks, service marks, and other materials
                            (“Vylor Materials”), are owned by or licensed to Vylor or its respective
                            licensors and are protected by applicable intellectual property laws. Subject to these Terms, Vylor grants you a limited, personal, non-exclusive,
                            non-transferable, and revocable right to access and use the Services for their
                            intended purposes.
                        </p>
                        <p>
                            Except as expressly permitted by these Terms or applicable law, you may not:
                        </p>
                        <ul>
                            <li>copy, reproduce, modify, or create derivative works from Vylor Materials;</li>
                            <li>publish, distribute, sell, rent, lease, license, or commercially exploit Vylor Materials;</li>
                            <li>remove copyright, trademark, or other proprietary notices;</li>
                            <li>reproduce the visual design or layout of the Services;</li>
                            <li>use Vylor trademarks or logos without prior written permission;</li>
                            <li>reverse engineer, decompile, disassemble, or attempt to derive source code from the Services, except where applicable law expressly permits such activity;</li>
                            <li>use Vylor Materials to create or develop a competing service.</li>
                        </ul>
                        <p>
                            All rights not expressly granted to you under these Terms are reserved by Vylor
                            and its licensors.
                        </p>
                        <h2>Restrictions on Use</h2>
                        <p>
                            You must not use the Services in a manner that may damage, disable, overburden,
                            or impair the Services or interfere with another person's use of them.
                        </p>
                        <p>You must not attempt to:</p>
                        <ul>
                            <li>gain unauthorized access to the Services or related systems;</li>
                            <li>circumvent security or authentication measures;</li>
                            <li>introduce viruses, malware, ransomware, spyware, or other harmful code;</li>
                            <li>interfere with servers, networks, or infrastructure supporting the Services;</li>
                            <li>conduct denial-of-service or similar attacks;</li>
                            <li>use automated systems to excessively access, copy, scrape, crawl, or extract information from the Services;</li>
                            <li>use bots, spiders, crawlers, scrapers, or data-mining tools except where expressly authorized;</li>
                            <li>use the Services for fraudulent, unlawful, abusive, threatening, or deceptive purposes;</li>
                            <li>impersonate Vylor or another person or organization;</li>
                            <li>collect or attempt to collect information about other users without authorization;</li>
                            <li>upload or transmit content that infringes the rights of another person;</li>
                            <li>use the Services to distribute unsolicited spam or other unauthorized communications;</li>
                            <li>attempt to circumvent any technical limitation or security feature of the Services.</li>
                        </ul>
                        <p>
                            Vylor may take appropriate action, including restricting or terminating access,
                            where unauthorized or abusive activity is identified.
                        </p>
                        <h2>Availability of Services</h2>
                        <p>
                            We aim to keep the Services available and functioning properly, but we do not
                            guarantee that the Services will always be available, uninterrupted, secure,
                            or error-free.
                        </p>
                        <p>The Services may occasionally be unavailable because of:</p>
                        <ul>
                            <li>scheduled maintenance;</li>
                            <li>upgrades or modifications;</li>
                            <li>technical failures;</li>
                            <li>telecommunications or internet service interruptions;</li>
                            <li>security incidents;</li>
                            <li>circumstances outside Our reasonable control; or</li>
                            <li>requirements imposed by applicable law or authorities.</li>
                        </ul>
                        <p>
                            Vylor may modify, suspend, restrict, or discontinue any part of the Services at
                            any time, including individual features or functionality.
                        </p>
                        <h2>Content and Information</h2>
                        <p>
                            We make reasonable efforts to provide useful and accurate information through
                            the Services. However, information available through the Services may contain
                            errors, omissions, inaccuracies, or information that becomes outdated. Information provided through the Services is intended for general informational
                            purposes unless expressly stated otherwise. You should independently verify information before relying on it where the
                            accuracy or completeness of that information is important to you. Nothing on the Services should be interpreted as professional, legal, financial,
                            medical, technical, or other specialized advice unless expressly identified as
                            such.
                        </p>
                        <h2>Third-Party Websites and Services</h2>
                        <p>
                            The Services may contain links to websites, applications, products,
                            advertisements, or services operated by third parties. These links are provided for convenience and do not necessarily constitute an
                            endorsement, sponsorship, or recommendation by Vylor.
                        </p>
                        <p>
                            Vylor does not control third-party websites or services and is not responsible
                            for:
                        </p>
                        <ul>
                            <li>their content;</li>
                            <li>availability;</li>
                            <li>accuracy;</li>
                            <li>security;</li>
                            <li>privacy practices;</li>
                            <li>terms and conditions;</li>
                            <li>products or services offered through them; or</li>
                            <li>any loss or damage resulting from your use of them.</li>
                        </ul>
                        <p>
                            Your interactions with third parties are governed by your relationship with
                            those third parties and their applicable terms and policies.
                        </p>
                        <h2>User Feedback and Submissions</h2>
                        <p>
                            If you voluntarily provide comments, suggestions, ideas, recommendations, or
                            other feedback regarding Vylor or the Services (“Feedback”), you agree that
                            Vylor may use that Feedback to improve, develop, operate, or promote its
                            Services. Unless otherwise agreed in writing, Feedback will not be treated as
                            confidential. You represent that you have the necessary rights and authority to provide any
                            Feedback you submit and that doing so does not violate the rights or
                            obligations you owe to another person or organization.
                        </p>
                        <h2>Disclaimer of Warranties</h2>
                        <p>
                            To the maximum extent permitted by applicable law, the Services and all
                            information, content, materials, and functionality provided through the
                            Services are made available on an “as is” and “as available” basis.
                        </p>
                        <p>Vylor does not guarantee that:</p>
                        <ul>
                            <li>the Services will meet your particular requirements;</li>
                            <li>the Services will always be available or uninterrupted;</li>
                            <li>the Services will be secure or free from errors or harmful components;</li>
                            <li>information provided through the Services will always be accurate, complete, or current; or</li>
                            <li>defects or errors will always be corrected.</li>
                        </ul>
                        <p>
                            To the maximum extent permitted by applicable law, Vylor disclaims all
                            warranties, representations, and conditions, whether express, implied,
                            statutory, or otherwise, including implied warranties of merchantability,
                            fitness for a particular purpose, title, and non-infringement.
                        </p>
                        <p>
                            Nothing in these Terms excludes or limits any warranty, right, or remedy that
                            cannot lawfully be excluded or limited under applicable law.
                        </p>
                        <h2>Limitation of Liability</h2>
                        <p>
                            To the maximum extent permitted by applicable law, Vylor and its directors,
                            officers, employees, representatives, affiliates, service providers,
                            licensors, and business partners will not be liable for any indirect,
                            incidental, special, consequential, exemplary, or punitive damages, or for any
                            loss of profits, revenue, business opportunities, data, goodwill, or
                            anticipated savings arising out of or relating to:
                        </p>
                        <ul>
                            <li>your access to or use of the Services;</li>
                            <li>your inability to access or use the Services;</li>
                            <li>interruption or unavailability of the Services;</li>
                            <li>reliance on information provided through the Services;</li>
                            <li>third-party websites, services, or content; or</li>
                            <li>any unauthorized access to or alteration of information.</li>
                        </ul>
                        <p>
                            Nothing in these Terms limits liability to the extent such limitation is
                            prohibited by applicable law. Where applicable law provides you with mandatory rights or remedies, those
                            rights and remedies remain unaffected.
                        </p>
                        <h2>Indemnification</h2>
                        <p>
                            To the maximum extent permitted by applicable law, you agree to indemnify and
                            hold harmless Vylor and its affiliates, directors, officers, employees,
                            representatives, contractors, service providers, licensors, and business
                            partners from claims, losses, liabilities, damages, costs, and expenses,
                            including reasonable legal fees, arising out of or relating to:
                        </p>
                        <ul>
                            <li>your violation of these Terms;</li>
                            <li>your misuse of the Services;</li>
                            <li>your violation of applicable law;</li>
                            <li>your infringement or violation of the rights of another person or organization; or</li>
                            <li>activities conducted through your account or credentials where you were responsible for preventing unauthorized use.</li>
                        </ul>
                        <p>
                            Vylor reserves the right to assume exclusive control of the defense of any
                            matter subject to indemnification, in which case you agree to reasonably
                            cooperate with Vylor in the defense of that matter.
                        </p>
                        <h2>Suspension and Termination</h2>
                        <p>
                            Vylor may suspend, restrict, or terminate your access to all or part of the
                            Services if:
                        </p>
                        <ul>
                            <li>you breach these Terms;</li>
                            <li>you violate applicable law;</li>
                            <li>your use creates a security or operational risk;</li>
                            <li>your activity may harm Vylor, another user, or a third party; or</li>
                            <li>suspension or termination is otherwise reasonably necessary to protect the Services or comply with legal requirements.</li>
                        </ul>
                        <p>
                            You may stop using the Services at any time.
                        </p>
                        <p>
                            Upon termination, provisions of these Terms that by their nature should
                            continue to apply will remain effective, including provisions concerning
                            intellectual property, disclaimers, limitation of liability, indemnification,
                            dispute resolution, and governing law.
                        </p>
                        <h2>Compliance with Applicable Laws</h2>
                        <p>
                            You agree to use the Services in compliance with all applicable local, state,
                            national, and international laws and regulations. Vylor may restrict access to certain Services, products, content, or
                            functionality where required by applicable law, regulatory requirements,
                            geographic restrictions, or other legitimate operational considerations.
                        </p>
                        <h2>Governing Law and Jurisdiction</h2>
                        <p>
                            These Terms will be governed by and interpreted in accordance with the laws
                            applicable to the jurisdiction in which Vylor is legally established, without
                            regard to conflict-of-law principles, unless applicable law requires otherwise. Subject to any mandatory rights you may have under applicable law, courts
                            having jurisdiction over the applicable Vylor entity will have jurisdiction
                            over disputes arising out of or relating to these Terms or your use of the
                            Services. Nothing in this section limits any statutory consumer rights or mandatory legal
                            protections that apply to you.
                        </p>
                        <h2>Electronic Communications</h2>
                        <p>
                            When you use the Services, communicate with Vylor electronically, or provide
                            your electronic contact information, you consent to receive communications
                            electronically where permitted by applicable law. Electronic communications may include account notifications, service
                            announcements, security notices, policy updates, transaction-related
                            communications, and other notices relating to the Services. Where applicable law permits electronic communications to satisfy a legal
                            writing requirement, you agree that electronic records and communications may
                            have the same legal effect as written communications.
                        </p>
                        <h2>Notices</h2>
                        <p>
                            Vylor may provide notices through the Services, by email, or through other
                            reasonable electronic means. You are responsible for keeping your account and contact information current
                            so that important communications can reach you.
                        </p>
                        <h2>Entire Agreement</h2>
                        <p>
                            These Terms, together with any applicable Additional Terms and policies
                            expressly incorporated into them, constitute the agreement between you and
                            Vylor concerning your use of the Services. These Terms supersede prior discussions, communications, or understandings
                            relating to the same subject matter, except where a separate written agreement
                            expressly governs a particular Service or relationship. If any provision of these Terms is determined to be invalid or unenforceable,
                            the remaining provisions will continue in full force and effect to the extent
                            permitted by law.
                        </p>
                        <h2>No Waiver</h2>
                        <p>
                            If Vylor does not immediately enforce any provision of these Terms, that does
                            not constitute a waiver of Our right to enforce that provision in the future. Any waiver must be made in writing by an authorized representative of Vylor
                            unless otherwise required by applicable law.
                        </p>
                        <div className="privacy-contact-box">
                            <h2>CONTACTING US</h2>
                            <p>
                                If you have questions, concerns, or requests relating to these Terms of Use,
                                you may contact Vylor at:
                            </p>
                            <p className="mb-2">
                                <strong>Email:</strong>{" "}
                                <a href="mailto:phipioneerapps@gmail.com">
                                    phipioneerapps@gmail.com
                                </a>
                            </p>
                            <p className="mb-0 text-muted">
                                We may update this contact information from time to time by publishing the
                                revised information on the Services.
                            </p>
                        </div>
                    </div>
                </div>
                <footer className="privacy-footer" id="footer">
                    <div className="privacy-footer-container">
                        <div className="row align-items-center">
                            <div className="col-12 col-md-6 text-center text-md-start mb-2 mb-md-0">
                                <p className="privacy-footer-text mb-0">
                                    Vylor Terms of Use
                                </p>
                            </div>
                            <div className="col-12 col-md-6 text-center text-md-end">
                                <p className="privacy-footer-text mb-0">
                                    &copy; {new Date().getFullYear()} -{" "}
                                    <a
                                        href="/Termsofuse"
                                        className="privacy-footer-link"
                                    >
                                        Vylor MCRC
                                    </a>
                                    . All rights reserved.
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>

                {/* Back to Top Button */}
                <button
                    type="button"
                    className={`privacy-back-to-top ${showScrollTop ? "visible" : ""}`}
                    onClick={scrollToTop}
                    aria-label="Back to top"
                    title="Back to top"
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="18 15 12 9 6 15" />
                    </svg>
                </button>
            </div>
        </div>
    );
};
export default Termsofuse;
